/**
 * Siglă rasterizată din SVG în public/resources/car-brands (ex. SVG Repo).
 * Logo negru → alb pe banda albastră prin filter CSS.
 */
export default function CarouselBrandSvg({ src, className }) {
  const href = `${process.env.PUBLIC_URL ?? ""}${src}`;

  return (
    <span className={className}>
      <img
        src={href}
        alt=""
        aria-hidden
        loading="lazy"
        decoding="async"
        className="h-[88%] w-[88%] object-contain brightness-0 invert"
      />
    </span>
  );
}
